import classNames from 'classnames'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { MISSION_TYPES, CIVILISATION_ID, DIFICULT_RANGES } from '../../app/constants'
import { Sphere_Elipse, Info } from '../../assets/img'
import { setPopUp } from '../../features/popUpSlice/popUpSlice'
import { extractStake } from '../../utilities/extractStake'
import { Commander } from '../containers/Commander'
import Button from '../ui/Button'

const MissionDayThree = ({ civilisation }) => {
  const [activeTab, setActiveTab] = useState('Mining')
  const user = useSelector((state) => state.user.userAccount)
  const epoch = useSelector((state) => state.epoch)
  const [epochDetails, setEpochDetails] = useState(epoch.epochDetails.find(e => 
    e.mission === MISSION_TYPES.indexOf(activeTab) + 1 
  && e.civilization === CIVILISATION_ID[civilisation] ))
  const [navIsOpen, setNavIsOpen] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    console.log("DEBUGGING EPOCH DETAILS:", epochDetails, MISSION_TYPES.indexOf(activeTab), CIVILISATION_ID[civilisation])
  })

  const [difficulty, setDifficulty] = useState(0)

  useEffect(() => {
   setEpochDetails(epoch.epochDetails.find(e => 
      e.mission === MISSION_TYPES.indexOf(activeTab) + 1 
    && e.civilization === CIVILISATION_ID[civilisation] ))
  }, [activeTab, civilisation, epoch])

  useEffect(() => {
    const leveOfStaking = epochDetails
    ? extractStake(epochDetails.total_staked) /
      parseFloat(epoch.glkCirculatingSupply)
    : 0
  setDifficulty(Math.sqrt(Math.log(1 + leveOfStaking)) * 100)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, epochDetails])

  

  const handleClaimGLK = (event) => {
    event.preventDefault()
    const claim = async () => {
      try {
        const result = await useRef.signTransaction(
          {
            actions: [
              {
                account: 'gtokenstakin',
                name: 'claimexprstk',
                authorization: [
                  {
                    actor: user.accountName,
                    permission: user.requestPermission,
                  },
                ],
                data: {
                  wallet: user.accountName,
                },
              },
            ],
          },
          {
            blocksBehind: 3,
            expireSeconds: 1200,
          },
        )
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    }
    claim()
  }
  const handleClaimNFT = (event) => {
    event.preventDefault()
    const claim = async () => {
      try {
        const result = await user.signTransaction(
          {
            actions: [
              {
                account: 'gtokenstakin',
                name: 'claimexprnft',
                authorization: [
                  {
                    actor: user.accountName,
                    permission: user.requestPermission,
                  },
                ],
                data: {
                  wallet: user.accountName,
                },
              },
            ],
          },
          {
            blocksBehind: 3,
            expireSeconds: 1200,
          },
        )
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    }
    claim()
  }

  return (
    <section className="flex flex-col w-full h-full lg:ml-8">
      <div className="flex lg:px-5 md:px-8 mx-auto h-full lg:w-full md:flex-nowrap flex-wrap justify-center gap-3 lg:p-2 md:p-0 lg:pr-4 xl:pr-10 lg:pt-0 lg:pb-4 overflow-auto">
        <div
          className="absolute top-[3%] right-[3%] cursor-pointer"
          onClick={() => dispatch(setPopUp({ isOpen: true, status: 'info-4' }))}
        >
          <Info />
        </div>
        <div className="hidden w-1/4 mr-3 my-auto lg:flex justify-center">
          <Commander civilisation={civilisation} />
        </div>
        <div className="flex lg:-ml-10 flex-col w-full lg:w-3/4 2xl:py-8 pb-10 span-2">
          <div
            className={
              (navIsOpen ? 'relative px-4' : ' flex flex-row px-4 ') +
              ' bg-[#5e3b13] lg:bg-transparent w-full lg:flex justify-between lg:w-11/12 mr-auto py-6 2xl:py-8 2xl:pb-10 '
            }
          >
            {MISSION_TYPES.map((mission, i) => {
              return (
                <Fragment key={mission}>
                  <div
                    value={mission}
                    onClick={() => {
                      setActiveTab(mission)
                    }}
                    className={
                      navIsOpen
                        ? ''
                        : (mission === activeTab ? '' : 'hidden lg:block') +
                          ' cursor-pointer'
                    }
                  >
                    <h3
                      className={classNames(
                        activeTab === mission ? 'text-cyanBlue' : 'text-white',
                        ['uppercase'],
                      )}
                    >
                      {`${mission} mission`}
                    </h3>
                  </div>
                  {i < 2 && (
                    <div className="hidden lg:block border-r border-gold w-[1px] h-full"></div>
                  )}
                </Fragment>
              )
            })}
            <span
              className={
                (navIsOpen ? 'absolute right-4 top-6' : '') +
                ' text-[#00fff0] lg:hidden'
              }
              onClick={() => setNavIsOpen(!navIsOpen)}
            >
              {navIsOpen ? (
                'X'
              ) : (
                <div className="w-[21px] h-[17px] flex flex-col justify-around">
                  <div className="h-[2px] w-full bg-[#00FFF0]" />
                  <div className="h-[2px] w-full bg-[#00FFF0]" />
                  <div className="h-[2px] w-full bg-[#00FFF0]" />
                </div>
              )}
            </span>
          </div>
          {MISSION_TYPES.map((mission, i) => (
            <div
              key={i + mission}
              className={classNames(
                activeTab === mission ? 'opacity-1 flex ' : 'opacity-0 hidden',
                [
                  'w-full 2xl:ml-0 lg:ml-5 pt-3 2xl:pt-10 2xl:px-20 gap-10 flex-wrap lg:flex-nowrap  justify-center items-center',
                ],
              )}
            >
              <div className="flex flex-col gap-y-5 w-full lg:w-1/2 lg:ml-3 text-center items-center lg:items-start  lg:text-left">
                <h3 className="text-purple pb-2 lg:-ml-3">{`${mission} mission success!`}</h3>
                <Button
                  className="w-5/6 lg:w-3/5 "
                  onClick={handleClaimGLK}
                  responsive
                >
                  Claim GLK Rewards
                </Button>
                <Button
                  className="w-5/6 lg:w-3/5"
                  onClick={handleClaimNFT}
                  responsive
                >
                  Claim NFT Rewards
                </Button>
                <div className="pt-4">
                  <p className="text-white">Total Mission Stats</p>
                  <p className="text-cyanBlue">{epochDetails ? Number(epochDetails?.total_staked.split(" ")[0] ?? 0.00).toFixed(2) : "0.00"} GLK Staked</p>
                  <p className="text-cyanBlue">{epochDetails ? Number(epochDetails?.total_power ?? 0.00).toFixed(2) : "0.00"} NFT MP</p>
                  <p className="text-cyanBlue">Mission Difficulty:  {difficulty <= DIFICULT_RANGES.easy
              ? "Easy"
              : difficulty > DIFICULT_RANGES.easy &&
                difficulty <= DIFICULT_RANGES.medium
              ? "Medium"
              : difficulty > DIFICULT_RANGES.medium &&
                difficulty <= DIFICULT_RANGES.hard
              ? "Hard"
              : difficulty > DIFICULT_RANGES.hard &&
                difficulty <= DIFICULT_RANGES.veryHard
              ? "Very Hard"
              : difficulty > DIFICULT_RANGES.veryHard
              ? "Ultra Hard"
              : ''}</p>
                </div>

                <div className="lg:pt-4">
                  <p className="text-white">Total Reward Pool</p>
                  <p className="text-cyanBlue">{epochDetails ? Number(epochDetails?.total_stake_token_reward.split(" ")[0] ?? 0.00).toFixed(2) : "0.00"} GLK Rewards</p>
                  <p className="text-cyanBlue">{epochDetails ? Number(epochDetails?.total_stake_nft_reward.split(" ")[0] ?? 0.00).toFixed(2) : "0.00"} NFT Rewards</p>
                </div>
              </div>
              <div className="flex w-full lg:w-1/2 items-center justify-center 2xl:pt-10">
                <img
                  className="w-1/2 lg:w-full"
                  src={Sphere_Elipse}
                  alt="animated sphere"
                ></img>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MissionDayThree
